module.exports = __webpack_public_path__ + "assets/img/txt-professionals-05.68ac9226.svg";